import { WEEKDAY_LABELS_SHORT, WEEKDAY_PICKER_LETTERS } from './constants';
import { parseCalendarDateString } from './anchor';

/**
 * @param {unknown} value
 * @returns {number[]|null} sorted unique UTC weekdays 0–6, or null if invalid
 */
export function parseWeekdaysArray(value) {
  if (value == null) return [];
  if (!Array.isArray(value)) return null;
  const out = [];
  for (const item of value) {
    const n = Number(item);
    if (!Number.isInteger(n) || n < 0 || n > 6) return null;
    if (!out.includes(n)) out.push(n);
  }
  out.sort((a, b) => a - b);
  return out;
}

export function deriveWeekdaysFromAnchor(anchorDate) {
  const d =
    typeof anchorDate === 'string'
      ? parseCalendarDateString(anchorDate)
      : anchorDate instanceof Date
        ? anchorDate
        : null;
  if (!d || Number.isNaN(d.getTime())) return [1];
  return [d.getUTCDay()];
}

export function describeWeekdaysList(weekdays) {
  const list = parseWeekdaysArray(weekdays);
  if (!list || list.length === 0) return '';
  if (list.length === 7) return 'every day';
  return list.map((d) => WEEKDAY_LABELS_SHORT[d]).join(', ');
}

export { WEEKDAY_PICKER_LETTERS };
